import { InjectionToken, Type } from '@angular/core';
import { UITableBaseColumn } from '../components/table-base-column/table-base-column.component';

export const UI_TABLE_CUSTOM_COLUMN =
  new InjectionToken<ITableCustomColumnCredentials>('ui-table-custom-column', {
    factory: () => <ITableCustomColumnCredentials>{},
  });

export interface ITableCustomColumnCredentials {
  [key: string]: ITableCustomColumnCredentialsItem;
}

export interface ITableCustomColumnCredentialsItem {
  component(): Promise<Type<UITableBaseColumn>>;
}
